const state = {
    stateId : [], 
}

const mutations = {
    REMOVE_STATE:(state, value) =>{
        state.stateId = [];
    },
    ADD_STATE: (state, value) => {
        for(var i = 0; i<value.stateid.length; i++){
            state.stateId.push(value.stateid[i])
        }
        
        // state.stateId.push(state.stateId)
        // state.stateId = [value.stateid, ...state.stateId];
    },
    REMOVE_STATE_ID: (state, value) => {
        console.log("STATE BEFORE RE ID", state.stateId);
        for(var i = 0; i<value.stateid.length; i++){
            console.log(value.stateid[i]);
            state.stateId = state.stateId.filter(element => ![value.stateid[i]].includes(element)); 
        }
        console.log("STATE AFTER RE ID", state.stateId);
    }
}
const actions = {  
    addstatedata({ commit }, payload ) {
        commit("ADD_STATE", payload);
    },  
    removestateid({ commit } ) {
        commit("REMOVE_STATE");
    }, 
    removesinglestateid({ commit }, payload ) {
        commit("REMOVE_STATE_ID", payload);
    }, 

    
}

const getters = {
    GET_STATE_ID: (state) => state.stateId,
}

export default{
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}

